import { useLingui } from '@lingui/react/macro';
import {
  DatePicker,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components';
import { useAtom, useSetAtom } from 'jotai';

import { useGetDateFNSLocale } from '@/locales/helpers';

import { insuranceStatusFilterAtom } from '../../../../modules/autoVerify/atoms';
import {
  operatoryFilterAtom,
  selectDateAtom,
  selectedProvidersAtom,
} from '../../../../modules/patientList/atoms';
import { PatientListPageLayoutContextMap } from '../../../../modules/patientList/types';
import { PatientSearch } from '../PatientSearch';

export const AutoVerifyTopbarContent = () => {
  const { t } = useLingui();
  const dateLocale = useGetDateFNSLocale();

  const [insuranceStatusFilter, setInsuranceStatusFilter] = useAtom(
    insuranceStatusFilterAtom,
  );
  const [date, setDate] = useAtom(selectDateAtom);
  const setSelectedOperatories = useSetAtom(operatoryFilterAtom);
  const setSelectedProviders = useSetAtom(selectedProvidersAtom);

  const handleSelectDate = (newDate: Date) => {
    setDate(newDate);
    setSelectedOperatories([]);
    setSelectedProviders([]);
  };

  return (
    <div className="vai-flex vai-items-center vai-gap-4">
      {/* Date Picker with Navigation */}
      <DatePicker
        date={date || undefined}
        setDate={handleSelectDate}
        placeholderText={t`Pick a date`}
        locale={dateLocale}
        showPreviousNextButtons
        showTodayButton
        todayButtonText={t`Back to Today`}
      />

      {/* Search Bar */}
      <div className="vai-w-80">
        <PatientSearch context={PatientListPageLayoutContextMap.AutoVerify} />
      </div>

      {/* Insurance Status Filter */}
      {/* <div className="vai-min-w-48">
        <Select
          value={insuranceStatusFilter}
          onValueChange={setInsuranceStatusFilter}
        >
          <SelectTrigger>
            <SelectValue placeholder={t`Insurance Status`} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t`All`}</SelectItem>
            <SelectItem value="active">{t`Active`}</SelectItem>
            <SelectItem value="inactive">{t`Inactive`}</SelectItem>
            <SelectItem value="pending">{t`Pending`}</SelectItem>
            <SelectItem value="unknown">{t`Unknown`}</SelectItem>
          </SelectContent>
        </Select>
      </div> */}
    </div>
  );
};
